
import { ComputedRef, defineComponent, onMounted } from "vue";
import { useStore } from "vuex";
import { computed } from "@vue/reactivity";
import { UserTeam } from "../../../../../domain/entities/entities";
import { wrapLoading } from "../../../utils/wrap_loading";

export default defineComponent({
  name: "TeamStatistics",
  setup() {
    const store = useStore();

    onMounted(async () => {
      await wrapLoading(async () => {
        await loadTeams();
      });
    });

    const loadTeams = async () => {
      try {
        await store.dispatch("userProfile_module/loadTeams");
      } catch (e) {
        console.log("[loadTeams] Error ", e);
        throw e;
      }
    };

    const teams: ComputedRef<UserTeam[]> = computed(
      () => store.getters["userProfile_module/teams"]
    );

    const teamsWithManagersNames = computed(() =>
      teams.value.map(team => ({
        ...team,
        managersNames:
          team.managers?.map(manager => manager.name).join(", ") ||
          "Nenhum gestor",
        usersNames:
          team.users?.map(user => user.name).join(", ") || "Nenhum membro"
      }))
    );

    return {
      teamsWithManagersNames
    };
  }
});
